import { defineStore } from 'pinia'
import { StoreHelper } from '../../helpers/storeHelper'

export const useLoginAccountStore = defineStore('loginAccount', {
  state: () => ({}),
  actions: {
    async loginReset({ headers, url, body }: { headers?: any, url?: string, body?: any }) {
      const { saveOne } = StoreHelper.loadRootState()
      await saveOne({ headers, url }, body)
    },
  }
})
